import { render } from "./predictive-search-empty.vue?vue&type=template&id=4dcd4af8"
import script from "./predictive-search-empty.vue?vue&type=script&lang=js"
export * from "./predictive-search-empty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__